<template>
  <div>
    <section class="">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'MyPackage' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CardInfo' }" tag="button">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CardLost' }" tag="button">
              <img src="img/member-icon-3.svg" alt="" />
              {{ $t("卡片掛失") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li>
            <button class="active">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("修改密碼") }}
            </button>
          </li>
        </ul>
        <div class="main">
          <div class="bg-box">
            <h1>{{ $t("修改密碼") }}</h1>
            <hr />
            <ul class="text-box">
              <li>
                <div>
                  <label for="password">{{ $t("舊密碼") }}</label>
                </div>
                <div>
                  <input
                    :placeholder="$t('請輸入舊密碼')"
                    type="password"
                    class="form-control"
                    id="password"
                    v-model="password"
                  />
                </div>
              </li>
              <li>
                <div>
                  <label for="newPassword">{{ $t("新密碼") }}</label>
                </div>
                <div>
                  <input
                    :placeholder="$t('請輸入新密碼')"
                    type="password"
                    class="form-control"
                    id="newPassword"
                    v-model="newPassword"
                  />
                </div>
              </li>
              <li>
                <div>
                  <label for="newPasswordConfirm">{{ $t("確認密碼") }}</label>
                </div>
                <div>
                  <input
                    :placeholder="$t('確認密碼')"
                    type="password"
                    class="form-control"
                    id="newPasswordConfirm"
                    v-model="newPasswordConfirm"
                  />
                </div>
              </li>
            </ul>
          </div>
          <div class="done-btn">
            <button @click="handleChangePassword">{{ $t("修改密碼") }}</button>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    會員資料: "會員資料",
    我的套票: "我的套票",
    卡片資料: "卡片資料",
    套票兌換: "套票兌換",
    卡片交易記錄: "卡片交易記錄",
    其他說明: "其他說明",
    修改密碼: "修改密碼",
    舊密碼: "舊密碼",
    請輸入舊密碼: "請輸入舊密碼",
    新密碼: "新密碼",
    請輸入新密碼: "請輸入新密碼",
    確認密碼: "確認密碼",
    錯誤: "錯誤",
    "取得會員資訊過程發生錯誤, 請稍後再試一次":
      "取得會員資訊過程發生錯誤, 請稍後再試一次",
    確定: "確定",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次":
      "重設密碼與確認重設密碼不符合, 請確認後再試一次",
    重設密碼成功: "重設密碼成功",
    卡片交易紀錄: "卡片交易紀錄",
  },
  en: {
    會員資料: "Member info",
    我的套票: "My pass",
    卡片資料: "Card info",
    套票兌換: "Redeem pass",
    卡片交易記錄: "Card record",
    其他說明: "Other info",
    修改密碼: "Change password",
    舊密碼: "Old password",
    請輸入舊密碼: "Please enter the old password",
    新密碼: "New password",
    請輸入新密碼: "Please enter the new password",
    確認密碼: "Confirm password",
    錯誤: "Error",
    "取得會員資訊過程發生錯誤, 請稍後再試一次": "Error. Please try again.",
    確定: "Confirm",
    "重設密碼與確認重設密碼不符合, 請確認後再試一次":
      "Please confirm the new password and try again.",
    重設密碼成功: "Password reset done.",
    卡片交易紀錄: "Activity",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Member",
  i18n,
  data() {
    return {
      UserData: {},
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
      IsTester: false,
    };
  },
  created: function () {
    let that = this;
    $.ajax({
      url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/Member",
      //url: "https://localhost:44321/Html/OrderInfo",
      type: "post",
      data: {
        token: Storage.get("ek_login_token"),
      },
      dataType: "json",
      error: function () {
        that.$swal({
          heightAuto: false,
          title: that.$t("錯誤"),
          text: that.$t("取得會員資訊過程發生錯誤, 請稍後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: that.$t("確定"),
        });
      },
      success: function (res) {
        // 判斷結果
        if (res.ok) {
          that.UserData = JSON.parse(res.data);
          that.IsTester = res.IsTester;
        } else if (res.error_msg) {
          var error_msg = JSON.parse(res.error_msg);
          if (res.toekn_error) {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
              willClose: function () {
                // 移除登入資訊
                Storage.remove("ek_login_token");
                // 回到首頁
                that.$router.push({
                  name: "Home",
                  params: {},
                });
              },
            });
          } else {
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        }
      },
    });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-change-password");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {
    handleChangePassword() {
      let password = this.password;
      let newPassword = this.newPassword;
      let newPasswordConfirm = this.newPasswordConfirm;
      if (newPassword != newPasswordConfirm) {
        this.$swal({
          heightAuto: false,
          title: this.$t("錯誤"),
          text: this.$t("重設密碼與確認重設密碼不符合, 請確認後再試一次"),
          icon: "error",
          allowOutsideClick: false,
          confirmButtonText: this.$t("確定"),
        });
        return;
      }
      let token = AES.encrypt(
        password + "|" + newPasswordConfirm
      );
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc +
          that.GLOBAL.subDirectory +
          "/Htmlv2/MemberChangePassword",
        //url: "https://localhost:44321/Html/MemberChangePassword",
        type: "post",
        data: {
          token: token,
          loginToken: Storage.get("ek_login_token"),
        },
        dataType: "json",
        error: function () {},
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("重設密碼成功"),
              showConfirmButton: false,
              timer: 3000,
              didDestroy: () => {
                Storage.remove("ek_login_token");
                location.href = "/#/Login";
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue